import React, { useState } from 'react';
import { Button, Checkbox, Typography, IconButton, FormControlLabel } from '@material-ui/core';
import { Add as AddIcon, DeleteForeverRounded as RemoveIcon, CalendarToday as CalendarIcon, } from '@material-ui/icons';
import './scss/park-project-cart.scss';
import DatePicker from 'react-mobile-datepicker';
import i18n from '../../i18n';

// import Notification from '../../component/snackbar/snackbar';
import moment from 'moment';
import { CartDefaultData, IParticipant, ParkProject } from './type';
import PhoneInput from '../../component/account/phone.component';
import { ParkModePrivacyAgreementDialog } from './park-mode-privacy-agreement';
import { ScheduleTimeRange } from '../../models';
import { LocalStorageManager } from '../../constants/tool-local-storage';
import { LOCAL_STORAGE_KEYS } from '../../constants/local-storage.constant';
import { createHashHistory } from 'history';
import { getQueryString } from '../../constants/tool-get-parms';
import { IS_EMAIL, IS_PHONE } from '../../constants/base.constant';
import { MdAccessTime, } from 'react-icons/md';
import { RiErrorWarningLine } from 'react-icons/ri';
/**
 * 游乐园项目购物车
 */
export default function ParkProjectCart({ projectDetail, selectedDateTime, show, onHoldData, defaultData, privacyPolicyList, goBack }: ParkProjectCartProps) {
    React.useEffect(() => {
        if (show) {
            if (defaultData) {
                setCreatorInfo(defaultData?.creatorInfo || {});
                setParticipants(defaultData?.participants || []);
                setAgreements(defaultData?.agreements || {
                    ruleClauses: false,
                    privacyPolicy: false,
                    disclaimer: false,
                });
                setIsCheckRule(false)
            }
        } else {
            onHoldData({ participants, creatorInfo, agreements, projectDetail })
        }
    }, [show]);
    const [participants, setParticipants] = useState<IParticipant[]>([]);
    // 添加参与者
    const addParticipant = () => {
        setParticipants([...participants, {
            email: '',
            firstName: '',
            lastName: '',
            birth: '',
        }]);
    };

    const [agreements, setAgreements] = useState({
        ruleClauses: false,
        privacyPolicy: false,
        disclaimer: false,
    });
    const [creatorInfo, setCreatorInfo] = useState<IParticipant>({
        phone: '',
        email: '',
        firstName: '',
        lastName: '',
        birth: '',
    });
    const [withCreator, setWithCreator] = useState(true);
    const [isCheckRule, setIsCheckRule] = useState(false);
    const [agreementDialog, setAgreementDialog] = useState({ open: false, title: '', htmlContent: '', key: '' });
    // 删除参与者
    const removeParticipant = (index: number) => {
        const newParticipants = participants.filter((_, i) => i !== index);
        setParticipants(newParticipants);
    };

    // 更新参与者信息
    const onChange = (index: number, field: string, value: string) => {
        const newParticipants = participants.map((participant, i) => {
            if (i === index) {
                return { ...participant, [field]: value };
            }
            return participant;
        });
        setParticipants(newParticipants);
    };
    // 计算总价
    const calculateTotal = () => {
        const participantsCount = participants.length + (withCreator ? 1 : 0);
        return (projectDetail.price || 0) * participantsCount;
    };

    const submitBtnActivity = (tip: boolean = false) => {
        // 校验参与者信息必填
        // 创建者
        if (!creatorInfo.email || !IS_EMAIL.test(creatorInfo.email) || !creatorInfo.firstName || !creatorInfo.lastName || !creatorInfo.birth
            || (creatorInfo.phonePrefix && creatorInfo.phone ? !IS_PHONE(creatorInfo.phonePrefix, creatorInfo.phone) : true)) {
            if (tip) {
                scrollTo(`creator`);
            }
            return false;
        }
        // 没有其他参与者 且没有勾选创建人参与
        if (!withCreator && participants.length === 0) {
            return false;
        }
        // participant
        let participantIndex = 0;
        // 校验其他参与者
        const hasInvalidParticipant = participants.some((participant, index) => {
            participantIndex = index;
            return !participant.firstName || !participant.lastName || !participant.birth;
        });

        if (hasInvalidParticipant) {
            if (tip) {
                scrollTo(`participant-${participantIndex}`);
            }
            return false;
        }

        if (!agreements.ruleClauses || !agreements.privacyPolicy || !agreements.disclaimer) {
            if (tip) {
                scrollTo('agreements');
            }
            return false;
        }
        return true;
    }

    const scrollTo = (id: string) => {
        const parentDom = document.getElementById('park-cart-content');
        const dom = document.getElementById(id);
        // 滚动条定位的dom,加动画
        if (parentDom && dom) {
            parentDom.scrollTo({
                top: dom.offsetTop - 50,
                behavior: 'smooth'  // 添加平滑滚动效果
            });
        }
    }

    const onSubmit = async () => {
        setIsCheckRule(true);
        if (submitBtnActivity(true)) {
            const restaurantStringId = getQueryString('string_id');
            // 保存缓存
            LocalStorageManager.setLocalStorage({
                path: LOCAL_STORAGE_KEYS.CHECKOUT_DATA,
                value: {
                    projectDetail: projectDetail,
                    associated_customers: ([{ ...creatorInfo, person_in_charge: true, is_participate_game: withCreator }] as IParticipant[]).concat(participants),
                    total: calculateTotal(),
                    actual_start_time: selectedDateTime.startDateTime,
                    // actual_end_time: selectedDateTime.endDateTime,
                    restaurantStringId
                }
            });
            goBack();
            // 跳转付款页面
            const history = createHashHistory();
            history.push(`/paymentMethodPage?string_id=${restaurantStringId}`);
        }

    };
    const checkRule = (obj: IParticipant) => {
        // error 
        const rule = {
            email: !IS_EMAIL.test(obj.email || ''),
            firstName: !obj.firstName,
            lastName: !obj.lastName,
            birth: !obj.birth,
            phone: obj.phonePrefix && obj.phone ? !IS_PHONE(obj.phonePrefix, obj.phone) : true,
            isCheckRule
        }
        // console.log(creatorInfo, isCheckRule);
        return rule

    }
    return (
        <div className='park-cart-container' style={{ display: show ? '' : 'none' }}>
            {/* 总计 */}
            <div className='price-info'>
                <Typography variant='body1'  >{i18n.t('park_mode_text_total')}: {calculateTotal().toFixed(2)} €</Typography>
            </div>
            <div className='content' id={'park-cart-content'}>
                <div className='section-title-box'>
                    <Typography className='section-title' variant='body1'>{i18n.t('park_mode_text_Participant_Information')}</Typography>
                </div>

                {/* 参与者信息 */}
                <Participant
                    itemKey='creator'
                    participant={creatorInfo}
                    onChange={(key: string, value: string) => {
                        const newCreatorInfo = { ...creatorInfo };
                        newCreatorInfo[key] = value;
                        setCreatorInfo(newCreatorInfo);
                    }}
                    onDelete={() => { }}
                    creator={true}
                    withCreator={withCreator}
                    onChangeCreatorJoin={(value: boolean) => {
                        setWithCreator(value)
                    }}
                    errorObj={checkRule(creatorInfo)}
                />
                <div className='add-participant-btn-box'>
                    <p className='add-participant-label'>
                        {i18n.t('park_mode_text_Add_other_participants')}
                    </p>
                    <Button
                        onClick={addParticipant}
                        className='add-participant-btn'
                    >
                        <AddIcon style={{ color: '#FF772B' }} />
                    </Button>
                </div>
                {/* 其他参与者信息 */}
                {participants.map((participantItem, index) => {
                    return (
                        <Participant
                            itemKey={'participant-' + index}
                            key={index}
                            participant={participantItem}
                            onChange={(key: string, value: string) => {
                                onChange(index, key, value);
                            }}
                            onDelete={() => { removeParticipant(index) }}
                            creator={false}
                            errorObj={checkRule(participantItem)}
                        />
                    )
                })}
                {/* 相关条款 */}
                <div className='agreements' id={'agreements'}>
                    <Typography className='agreement-title'>{i18n.t('park_mode_text_Confirm_relevant_terms')}</Typography>
                    {Object.keys(privacyPolicyList).map((key) => {
                        return (
                            <div key={key} className='agreement-item'>
                                <Typography onClick={() => {
                                    setAgreementDialog({
                                        open: true,
                                        htmlContent: privacyPolicyList?.[key]?.content || '',
                                        title: privacyPolicyList?.[key]?.title || '',
                                        key
                                    })
                                }} className='agreement-label'>{privacyPolicyList?.[key]?.title} *</Typography>
                                <Checkbox
                                    checked={agreements[key]}
                                    onChange={(e) => setAgreements({ ...agreements, [key]: e.target.checked })}
                                />
                            </div>
                        )
                    })}
                    {agreementDialog.open &&
                        <ParkModePrivacyAgreementDialog
                            title={agreementDialog.title}
                            handleClose={() => {
                                setAgreementDialog({ open: false, htmlContent: '', title: '', key: '' });
                            }}
                            htmlContent={agreementDialog.htmlContent}
                            onConfirm={() => {
                                setAgreements({ ...agreements, [agreementDialog.key]: true })
                                setAgreementDialog({ open: false, htmlContent: '', title: '', key: '' });
                            }}
                        />}
                </div>
            </div>

            <div className='footer'>
                <Button
                    variant='contained'
                    fullWidth
                    className={`submit-btn ${submitBtnActivity() ? '' : 'submit-btn-disabled'}`}
                    onClick={async () => { await onSubmit() }}
                >
                    {i18n.t('delivery_address_page_text_address_confirmed')}
                </Button>
            </div>

        </div>
    );
}




interface ParkProjectCartProps {
    projectDetail: ParkProject;
    selectedDateTime: {
        startDateTime: string,
        endDateTime: string
    };
    show: boolean;
    onHoldData: (data: CartDefaultData) => void;
    defaultData: CartDefaultData;
    privacyPolicyList: {
        ruleClauses: {
            title: string,
            content: string
        },
        privacyPolicy: {
            title: string,
            content: string
        },
        disclaimer: {
            title: string,
            content: string
        }
    },
    goBack: () => void;
}


/**
 * 选择项目日期时间
 * @param props 
 * @returns 
 */
export function ProjectTime(
    props: {
        timeRanges: { start_time: string, end_time: string, disabled: boolean }[];
        onConfirm: (timeRange: ScheduleTimeRange, selectDate: string) => void;
        defaultData: { timeRange?: ScheduleTimeRange, selectDate?: string };
        onChange?: (timeRange: ScheduleTimeRange, selectDate: string) => void;
        onSelectDate: (date: string) => void;
        collapse: boolean;
        maxDate: number;
    }

) {
    const { timeRanges, onConfirm, defaultData, onChange, onSelectDate, maxDate } = props;
    const [isShowDatePicker, setIsShowDatePicker] = useState<boolean>(false);

    const [selectedTime, setSelectedTime] = useState<ScheduleTimeRange | null>(defaultData.timeRange || null);
    const [date, setDate] = useState<string>(defaultData.selectDate ? defaultData.selectDate : moment().format('DD/MM/YYYY'));
    const [dialogDate, setDialogDate] = useState<Date>(defaultData?.selectDate ? new Date(defaultData.selectDate) : new Date());
    const handleSelect = async (date: Date) => {
        setIsShowDatePicker(false);
        setDate(moment(date).format('DD/MM/YYYY'));
        onSelectDate(moment(date).format('DD/MM/YYYY'));
        onChange?.({}, moment(date).format('DD/MM/YYYY'));
        setSelectedTime(null);
    }
    React.useEffect(() => {

        if (props.collapse) {
            setSelectedTime(defaultData.timeRange || null);
            setDate(defaultData.selectDate ? defaultData.selectDate : moment().format('DD/MM/YYYY'));
            setDialogDate(defaultData?.selectDate ? new Date(moment(defaultData.selectDate, 'DD/MM/YYYY').format('YYYY-MM-DD')) : new Date());
        }
    }, [props.collapse])

    const weekDays = i18n.t('dayNamesShort').split(',');

    return (
        <div className='time-selection'>
            <Typography variant='subtitle1' className='section-title'>
                {i18n.t('park_mode_text_chose_time')}
            </Typography>
            <div className='date-picker'>
                <div
                    className='date-picker-button'
                    onClick={() => setIsShowDatePicker(true)}
                >
                    <Typography className='date-text'>{date}</Typography>
                    <CalendarIcon className='calendar-icon' />
                </div>
            </div>
            <div className='time-slots'>
                {timeRanges?.map((item, index) => (
                    <Button
                        key={`${index}`}
                        variant='outlined'
                        className={`time-slot-btn ${selectedTime?.start_time === item?.start_time ? 'selected' : ''} ${item?.disabled ? 'disabled' : ''}`}
                        disabled={item?.disabled}
                        onClick={() => {
                            setSelectedTime(item);
                            onChange?.(item, date);
                        }}
                    >
                        {item?.start_time ? moment(item.start_time, 'HH:mm').format('HH:mm') : ''}
                    </Button>
                ))}
            </div>
            {timeRanges?.length == 0 && <div className='no-time-available-box'>
                <div className='no-time-available-icon'>
                    <MdAccessTime style={{ color: '#9ca3ad', fontSize: '30px' }} />
                </div>
                <Typography variant='body1' className='no-time-available-title'>{i18n.t('park_mode_text_no_available_time')}</Typography>
                <Typography variant='body1' className='no-time-available-desc'>{i18n.t('park_mode_text_no_slots_for_date')}</Typography>
                <div className='no-time-available-tip-box'>
                    {/* icon info */}
                    <RiErrorWarningLine style={{ color: '#FFA726', fontSize: '18px', marginRight: '4px' }} />
                    <Typography variant='body1' className='no-time-available-tip'>
                        {i18n.t('park_mode_text_click_calendar_to_change_date')}
                    </Typography>
                </div>
            </div>}
            <div className='confirm-btn-box'>
                <Button
                    variant='contained'
                    className={`confirm-btn ${selectedTime ? '' : 'confirm-btn-disabled'}`}
                    onClick={() => {
                        selectedTime && onConfirm?.(selectedTime, date)
                    }}
                >
                    {i18n.t('park_mode_text_chose_time_confirm')}
                </Button>
            </div>
            {/* 日期插件 */}
            {<DatePicker
                showCaption={true}
                value={dialogDate}
                isOpen={isShowDatePicker}
                onSelect={(time: Date) => handleSelect(time)}
                onCancel={() => setIsShowDatePicker(false)}
                onChange={(val) => { setDialogDate(val) }}
                dateConfig={{
                    // 'year': {
                    //     format: 'YYYY',
                    //     caption: 'Year',
                    //     step: 1,
                    // },
                    'month': {
                        format: 'MM',
                        caption: 'Month',
                        step: 1,
                    },
                    'date': {
                        format: (val: number) => moment(val).format('DD') + ' ' + weekDays[moment(val).day()],
                        caption: `${i18n.t('payment_page_text_date')}`,
                        step: 1
                    },
                }}
                min={new Date(moment().format('YYYY-MM-DD'))}
                max={new Date(moment().add(maxDate, 'days').format('YYYY-MM-DD'))}
                // max={maxTime}
                confirmText={i18n.t('general_text_confirm')}
                cancelText={i18n.t('general_text_cancel')}
            />}
        </div >
    )
}



/**
 * 参与人信息
 */
function Participant(
    {
        participant,
        onChange,
        onDelete,
        creator,
        withCreator,
        onChangeCreatorJoin,
        errorObj,
        itemKey
    }: {
        participant: IParticipant,
        onChange: (key: string, value: string) => void,
        onDelete: () => void,
        creator: boolean;
        withCreator?: boolean;
        onChangeCreatorJoin?: (value: boolean) => void;
        errorObj?: {
            phone: boolean;
            email: boolean;
            firstName: boolean;
            lastName: boolean;
            birth: boolean;
            phonePrefix?: boolean;
            isCheckRule: boolean;
        },
        itemKey: string
    },
) {
    const [isShowDatePicker, setIsShowDatePicker] = useState<boolean>(false);
    const [dialogDate, setDialogDate] = useState<Date>(participant?.birth ? new Date(participant.birth) : new Date());
    const [checkItem, setCheck] = useState<boolean>(false);
    const handleSelect = async (time: Date) => {
        setIsShowDatePicker(false);
        onChange('birth', moment(time).format('DD/MM/YYYY'))
    }
    const handleChange = (key: string, value: string) => {
        setCheck(true);
        onChange(key, value);
    }
    const check = checkItem || errorObj?.isCheckRule;
    return (
        <div className='participant-section' id={itemKey}>
            {/* 删除按钮 */}
            <div className='remove-btn-container'>
                {!creator && (
                    <IconButton
                        style={{ backgroundColor: '#ffdc33', color: '#44415E' }}
                        size='small'
                        onClick={onDelete}
                        className='remove-btn'
                    >
                        <RemoveIcon />
                    </IconButton>
                )}
            </div>
            {/* 只在第一个参与者表单中 显示电子邮箱 */}
            {
                creator && <ParticipantInput
                    title={i18n.t('account_page_text_email')}
                    value={participant.email || ''}
                    onChange={(value: string) => {
                        handleChange('email', value);
                    }}
                    error={check ? errorObj?.email : false}
                />
            }
            <ParticipantInput
                title={i18n.t('reservation_page_text_first_name')}
                value={participant.firstName || ''}
                onChange={(value: string) => {
                    // value长度最长30位
                    if (value.length > 30) {
                        return;
                    }
                    handleChange('firstName', value);
                }}
                error={check ? errorObj?.firstName : false}
            />
            <ParticipantInput
                title={i18n.t('reservation_page_text_last_name')}
                value={participant.lastName || ''}
                onChange={(value: string) => {
                    // value长度最长30位
                    if (value.length > 30) {
                        return;
                    }
                    handleChange('lastName', value);
                }}
                error={check ? errorObj?.lastName : false}
            />
            <ParticipantInput
                title={i18n.t('text_birthday')}
                value={participant.birth || ''}
                onChange={(value: string) => {
                    handleChange('birth', value);
                }}
                content={
                    <div
                        className='date-picker-button'
                        onClick={() => setIsShowDatePicker(true)}
                    >
                        <Typography className='date-text'>{participant.birth ? moment(participant.birth, 'DD/MM/YYYY').format('DD/MM/YYYY') : ''}</Typography>
                        <CalendarIcon className='calendar-icon' />
                    </div>
                }
                error={check ? errorObj?.birth : false}
            />
            {creator &&
                <ParticipantInput
                    title={i18n.t('reservation_page_text_phone')}
                    value={participant.birth || ''}
                    onChange={(value: string) => {
                        handleChange('birth', value);
                    }}
                    content={
                        <PhoneInput
                            className='phone-main'
                            defaultValue={participant.phone || ''}
                            phonePrefix={participant.phonePrefix}
                            onChangePhonePrefix={(value: string) => {
                                handleChange('phonePrefix', value);
                            }}
                            onChange={(value: string) => {
                                handleChange('phone', value);
                            }}
                        />
                    }
                    error={check ? errorObj?.phone : false}
                />

            }
            {/* 只在第一个参与者表单中添加此选项 */}
            {
                creator && (
                    <div className='self-participant-check'>
                        <FormControlLabel
                            labelPlacement='start'
                            control={
                                <Checkbox
                                    checked={!!withCreator}
                                    onChange={(e) => onChangeCreatorJoin?.(e.target.checked)}
                                />
                            }
                            label={i18n.t('park_mode_text_self_participant')}
                        />
                    </div>
                )
            }
            {/* 日期插件 */}
            {<DatePicker
                showCaption={true}
                value={dialogDate}
                isOpen={isShowDatePicker}
                onSelect={(time: Date) => handleSelect(time)}
                onCancel={() => setIsShowDatePicker(false)}
                onChange={(val) => { setDialogDate(val) }}
                dateConfig={{
                    'year': {
                        format: 'YYYY',
                        caption: 'Year',
                        step: 1,
                    },
                    'month': {
                        format: 'MM',
                        caption: 'Month',
                        step: 1,
                    },
                    'date': {
                        format: 'DD',
                        caption: `${i18n.t('payment_page_text_date')}`,
                        step: 1
                    },
                }}
                max={new Date(moment().add(1, 'day').format('YYYY-MM-DD'))}
                // max={maxTime}
                confirmText={i18n.t('general_text_confirm')}
                cancelText={i18n.t('general_text_cancel')}
            />}
        </div >
    )

}

function ParticipantInput(props: { title: string, value: string, onChange: (value: string) => void, error?: boolean; content?: JSX.Element }) {
    return (
        <div className={'participant-input'}>
            <div className='title'>{props.title}</div>
            <div className={`radiusInputBox ${props.error ? 'error' : ''}`}>
                {props.content ? props.content :
                    <input
                        className='radiusInput'
                        value={props.value}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            props.onChange(e.target.value)
                        }}
                    />
                }
            </div>
        </div>
    )
}

